/**
 * BottomNavigation Component - Mobile bottom navigation bar
 * Displays main app sections for quick access on mobile devices
 *
 * Položky sa riadia modulmi používateľa — backend ich od 5. 10. 2026 vynucuje,
 * takže bez modulu by kliknutie skončilo na 403.
 */
import React from 'react';
import { useViewStore } from '../../store/viewStore';
import { useAuthStore } from '../../stores/authStore';
import './BottomNavigation.css';

export const BottomNavigation: React.FC = () => {
  const { viewMode, setViewMode } = useViewStore();
  const { hasModule } = useAuthStore();

  return (
    <nav className="bottom-navigation">
      <button
        className={`bottom-nav-item ${viewMode === 'map' ? 'active' : ''}`}
        onClick={() => setViewMode('map')}
        aria-label="Mapa"
      >
        <span className="bottom-nav-icon">🗺️</span>
        <span className="bottom-nav-label">Mapa</span>
      </button>

      {hasModule('customer_management') && (
        <button
          className={`bottom-nav-item ${viewMode === 'customer-search' ? 'active' : ''}`}
          onClick={() => setViewMode('customer-search')}
          aria-label="Nájdi zákazníka"
        >
          <span className="bottom-nav-icon">🔎</span>
          <span className="bottom-nav-label">Nájdi</span>
        </button>
      )}

      <button
        className={`bottom-nav-item ${viewMode === 'documentation' ? 'active' : ''}`}
        onClick={() => setViewMode('documentation')}
        aria-label="Dokumentácia"
      >
        <span className="bottom-nav-icon">📚</span>
        <span className="bottom-nav-label">Docs</span>
      </button>

      {hasModule('customer_management') && (
        <button
          className={`bottom-nav-item ${viewMode === 'orders' ? 'active' : ''}`}
          onClick={() => setViewMode('orders')}
          aria-label="Objednávky"
        >
          <span className="bottom-nav-icon">📝</span>
          <span className="bottom-nav-label">Objed.</span>
        </button>
      )}

      {hasModule('customer_management') && (
        <button
          className={`bottom-nav-item ${viewMode === 'customers' ? 'active' : ''}`}
          onClick={() => setViewMode('customers')}
          aria-label="Zákazníci"
        >
          <span className="bottom-nav-icon">👥</span>
          <span className="bottom-nav-label">Zák.</span>
        </button>
      )}

      {hasModule('installation_checklist') && (
        <button
          className={`bottom-nav-item ${viewMode === 'tasks' ? 'active' : ''}`}
          onClick={() => setViewMode('tasks')}
          aria-label="Úlohy"
        >
          <span className="bottom-nav-icon">✅</span>
          <span className="bottom-nav-label">Úlohy</span>
        </button>
      )}
    </nav>
  );
};
